import React, { useState } from "react";
import axios from "axios";

const usePermission = ({
    onFinish = ({ axiosMode, status, values }) => { 

    }, //{ axiosMode, status, values }
    onBefore = () => { }, //{ axiosMode, status }
}) => {
    const mainApi = ``
    const [data, setData] = useState([])
    const getPermissionSelfDatas = ({
        cur_page,
        size,
    }) => {
        axios.get(`/permission_management/permission_manage_self`, {
            params: {
                cur_page,
                size,
            },
        })
            .then((response) => {
                let data = response.data
                setData(data.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }

            });
    }

    return {
        permissionsSelfDatas: data,
        getPermissionSelfDatas
    }

}
export { usePermission }